import { jsx as n, jsxs as k } from "react/jsx-runtime";
import { FileSourceEnum as p } from "@systemeio/file-manager";
import { Tooltip as g } from "@systemeio/ui";
import { useEditorState as T } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as I } from "react";
import { twMerge as t } from "tailwind-merge";
import { ToolbarButton as f } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as b, TOOLTIP_STYLES as L } from "../../constants/default-styles.mjs";
import u from "../../icons/link-icon.mjs";
import { useTranslation as d } from "../../i18n.mjs";
import { LinkBubbleMenu as x } from "./link-bubble-menu.mjs";
import { useUpdateLinkColor as E } from "./use-update-link-color.mjs";
import { isImageSelected as h } from "../image-extension/utils/is-image-selected.mjs";
const P = (r, s) => {
  const a = s == null ? void 0 : s.color, c = (s == null ? void 0 : s.fileSource) ?? p.TextEditor, { t: m } = d(), l = T({
    editor: r,
    selector: ({ editor: e }) => ({
      isEditable: (e == null ? void 0 : e.options.editable) ?? !1,
      isActive: e == null ? void 0 : e.isActive("link"),
      isImageSelected: h(e)
    })
  }), o = (l == null ? void 0 : l.isActive) ?? !1, i = !(l != null && l.isEditable) || !!(l != null && l.isImageSelected);
  return E(r, a), I(() => {
    const e = () => {
      if (!r) return null;
      r.isActive("link") ? r.chain().focus() : r.chain().focus().extendMarkRange("link").setLink({ href: "" }).updateAttributes("link", { color: a }).run();
    };
    return {
      toolbarRender: /* @__PURE__ */ n(g, { disabled: i, label: m("link"), ...L, children: /* @__PURE__ */ n(
        f,
        {
          disabled: i,
          className: t(o && "bg-brand-primary/10 main-transition-colors"),
          onClick: e,
          children: /* @__PURE__ */ n(u, { className: b(i) })
        }
      ) }),
      tooltipRender: /* @__PURE__ */ k(
        f,
        {
          disabled: i,
          className: t(
            o && "bg-brand-primary/10 main-transition-colors",
            "flex gap-1"
          ),
          onClick: e,
          children: [
            /* @__PURE__ */ n(u, { className: b(i) }),
            m("link")
          ]
        }
      ),
      additionalRender: /* @__PURE__ */ n(x, { editor: r, fileSource: c, options: s })
    };
  }, [i, m, o, r, c, a]);
};
export {
  P as useLinkExtensionToolbar
};
